export class Book {
  // Visiblement déclarer des propriétés hors du constructeur les rend optionnelles
  // Moi ça me met une erreur qui me met un ! après photo, pas lui (ça parle de définitive assignment)
  photo!: string;
  constructor(public title: string, public author: string) {}
}